import moduleName from './main.module';
import './entry.module.js';
import './main.module.js';
import './toggle-switch/toggle_switch.directive.js';
export default moduleName;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-toggle-switch/entry.module.js